module.exports = __webpack_public_path__ + "media/images/svg/jobs/nurse-e493c559a859926e08cf19185fe697ed.svg";